import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    commentnum: 0,
    contentid: '',
    contentname: '',
    contentuserid: '',
    url: window.location.origin
  },
  mutations: {
    SET_CONTENT_ID(state, id) { state.contentid = id },
    SET_COMMENT_NUM(state, num) { state.commentnum = num },
    SET_CONTENT_INFO(state, { name, userid }) {
      state.contentname = name
      state.contentuserid = userid
    }
  },
  actions: {
    setcontentid({ commit }, id) { commit('SET_CONTENT_ID', id) },
    setcommentnum({ commit }, num) { commit('SET_COMMENT_NUM', num) },
    setcontentinfo({ commit }, info) { commit('SET_CONTENT_INFO', info) }
  },
  modules: { user }
})
